import React from 'react'

import { Button, SliderItem } from 'shared/components'
import { scrollIntoElement } from 'shared/utils'
import { MainWorkAreasId } from '../MainWorkAreas/MainWorkAreas'

import classNames from 'classnames'
import classes from './FirstBlock.module.scss'

export const FirstBlock = (): JSX.Element => {
  const renderChild = (title: string, decr: string) => {
    const className = classNames(classes.slider, classes.slider_first)

    return (
      <div className={className}>
        <div className="container reveal-from-bottom-large">
          <div className={`${classes.info} row`}>
            <div className="col-xs-12">
              <h1 className={classes.title} key={`title_activeSlider`}>
                {title}
              </h1>
            </div>
            <div className="col-xs-12 col-sm-8">
              <p className={classes.description}>{decr}</p>
            </div>
            <div className="col-xs-12 col-sm-4"></div>
            <div className="col-xs-12">
              <Button
                btnType="primary"
                className={classes.btn}
                onClick={() =>
                  scrollIntoElement(MainWorkAreasId, undefined, undefined, true)
                }
              >
                Узнать больше
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const items: SliderItem[] = [
    {
      child: renderChild(
        'KION\nМЫ СОЗДАЕМ ИСТОРИИ,\nКОТОРЫЕ УДИВЛЯЮТ',
        'Оригинальные фильмы и сериалы для широкой аудитории, инвестиции\nв кинопроизводство и совместное продюсирование проектов.'
      ),
    },
  ]
  return (
    <div className={classes.wrap}>
      <div className={classes.container}>
        {items.map((item, itemIndex) => (
          <React.Fragment key={itemIndex}>{item.child}</React.Fragment>
        ))}
        <div className={classes.mouse_container}>
          <div className={classes.mouse_icon}>
            <span className={classes.mouse_wheel}></span>
          </div>
        </div>
      </div>
    </div>
  )
}
